import { ReceiptPrintHistory, ReceiptPrintName } from '@/types'
import dayjs from 'dayjs'
import { authUserStore } from '@/utils/store-accessor'
import { CommandType } from '@/types/websocket'

export default class ReceiptHistoryService {
  public save(
    commandType: CommandType,
    receiptPrintName: ReceiptPrintName,
    data: any,
    subject: string,
    maxPrintCount?: number,
    customerCode?: string
  ) {
    const history: ReceiptPrintHistory = {
      commandType,
      receiptPrintName,
      subject,
      data,
      dateTime: dayjs().format('YYYY/MM/DD HH:mm:ss'),
      maxPrintCount,
      customerCode
    }

    const items: ReceiptPrintHistory[] = this.load()
    items.unshift(history)

    this.store(items.slice(0, 100))
  }

  public load(): ReceiptPrintHistory[] {
    const item = localStorage.getItem(this.storageKey())
    return item ? JSON.parse(item) : []
  }

  private store(items: ReceiptPrintHistory[]): void {
    localStorage.setItem(this.storageKey(), JSON.stringify(items))
  }

  storageKey() {
    return 'receipt_history_' + authUserStore.authUser.id
  }
}
